import { StowageRulePropertyContext } from '../../../types/ViewModel/Stowage/StowageRule/StowageRulePropertyContext';
import { StowageRulePropertyBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulePropertyBM';
import { getNestedValue } from 'src/utils/propertyUtils';

const logPropertyManager: boolean = false;

export class PropertyManager {
    public getPropertyValue(context: StowageRulePropertyContext, property: StowageRulePropertyBM): any {
        let value: any = undefined;

        const fieldPathHandlers: { [key: string]: () => any } = {
            areTankContentsUscgCompatible: () => context.dataAccessor.areTankContentsUscgCompatible(context.tankContent, context.adjacentTankContent),
            getCargoNominatedWeight: () => context.dataAccessor.getCargoNominatedWeight(context.cargo),
            getCargoNominatedWeightUpToThisCall: () => context.dataAccessor.getCargoNominatedWeightUpToThisCall(context.cargo, context.berthCall),
            getCargoStowedWeight: () => context.dataAccessor.getCargoStowedWeight(context.cargo),
            getCargoTemperature: () => context.dataAccessor.getCargoTemperature(context.cargo, context.tank),
            getCargoOperationStowedWeight: () => context.dataAccessor.getCargoOperationStowedWeight(context.cargoOperation),
            getCargoOperationUnstowedWeight: () => context.dataAccessor.getCargoOperationUnstowedWeight(context.cargoOperation),
            getCargoOperationNominatedWeight: () => context.dataAccessor.getCargoOperationNominatedWeight(context.cargoOperation),
            getCoatingCompatibility: () => context.dataAccessor.getCoatingCompatibility(context.cargo, context.tank),
            getFillRatio: () => context.dataAccessor.getFillRatio(context.tankContent),
            getStowedWeight: () => context.dataAccessor.getStowedWeight(context.tankContent),
            getTankContentLitreWeight: () => context.dataAccessor.getTankContentLitreWeight(context.tankContent),
            getTankContentVolume: () => context.dataAccessor.getTankContentVolume(context.tankContent),
            getTankMaxTemperature: () => context.dataAccessor.getTankMaxTemperature(context.tank),
            hasIllegalCommingling: () => context.dataAccessor.hasIllegalCommingling(context.tankContent),
            isOtherCargoType1Or2Stowed: () => context.dataAccessor.isOtherCargoType1Or2Stowed(context.cargo, context.berthCall),
            isDeckTank: () => context.dataAccessor.isDeckTank(context.tank),
            isPortCallDeparted: () => context.dataAccessor.isPortCallDeparted(context.cargoOperation.berthCall.portCall),
            isTankBlocked: () => context.dataAccessor.isTankBlocked(context.berthCall, context.tank),
            isManualLoadingOrUnloadingOperation: () => context.dataAccessor.isManualLoadingOrUnloadingOperation(context.cargoOperation),
            isContractWeightEdited: () => context.dataAccessor.isContractWeightEdited(context.cargoOperation),
        };

        if (property.referenceValue) {
            value = this.getConvertedValue(property, property.referenceValue);
            this.logPropertyValue(property.name, value);
        } else if (fieldPathHandlers[property.fieldPath]) {
            value = fieldPathHandlers[property.fieldPath]();
            this.logPropertyValue(property.fieldPath, value);
        } else {
            value = getNestedValue(context, property.fieldPath);
            if (property.type === 'string' && !value) {
                value = '';
            }
            this.logPropertyValue(`${property.name} / ${property.fieldPath}`, value);
        }

        return value;
    }

    private getConvertedValue(property: StowageRulePropertyBM, value: string): any {
        switch (property.type) {
            case 'string':
                return value;
            case 'number':
                return Number(value);
            case 'boolean':
                return value === 'true';
            default:
                return value;
        }
    }

    private logPropertyValue(name: string, value: any): void {
        if (logPropertyManager) {
            console.log(`Property value for ${name}:`, value);
        }
    }
}
